<section
  class="mock-test-section"
  id="mock-tests"
  [class.dashboard-mode]="isDashboard"
>
  <div class="mock-test-container">
    <div class="flex items-center justify-between gap-4 mb-8">
      <div>
        <h2 class="mock-test-title ms-3">
          AI <span class="brand-gradient-text">Mock Interview</span>
        </h2>
        <p class="ms-3">Practice realistic AI-powered video interviews and receive instant, personalized feedback</p>
      </div>
      <button
        class="btn-view-all"
        [routerLink]="
          isDashboard ? '/student-dashboard/placement-prep' : '/mock-interview'
        "
        data-testid="mock-test-view-all"
      >
        <span>View all</span>
        <svg
          aria-hidden="true"
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M5 12h14"></path>
          <path d="m12 5 7 7-7 7"></path>
        </svg>
      </button>
    </div>

    <div class="relative carousel-wrapper group">
      <button
        type="button"
        (click)="scrollLeft()"
        *ngIf="!isAtStart"
        class="arrow-btn arrow-left"
        aria-label="Previous interviews"
      >
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
          viewBox="0 0 24 24"
        >
          <path d="M15 19l-7-7 7-7"></path>
        </svg>
      </button>

      <div class="mock-interview-grid" #interviewGrid (scroll)="onGridScroll()">
        <ng-container *ngIf="isLoading">
          <div class="interview-card skeleton-card" *ngFor="let s of [1, 2, 3]">
            <div class="card-header">
              <div class="left-section">
                <div class="skeleton-shimmer skeleton-logo"></div>
                <div class="title-section flex-1">
                  <div class="skeleton-shimmer skeleton-title"></div>
                  <div class="skeleton-shimmer skeleton-subtitle"></div>
                </div>
              </div>
              <div class="skeleton-shimmer skeleton-pill"></div>
            </div>
            <div class="card-body">
              <div class="meta-row">
                <div class="skeleton-shimmer skeleton-meta"></div>
                <div class="skeleton-shimmer skeleton-meta"></div>
              </div>
              <div class="skeleton-shimmer skeleton-btn"></div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="!isLoading && mockInterviews.length === 0">
          <div class="no-data-container">
            <i class="bi bi-clipboard-x"></i>
            <p *ngIf="searchTerm">
              No practice interviews found matching "{{ searchTerm }}".
            </p>
            <p *ngIf="!searchTerm">
              No practice interviews available at this time.
            </p>
            <button
              class="clear-filter-btn"
              *ngIf="searchTerm"
              (click)="clearSearch()"
            >
              <i class="bi bi-x-circle"></i> Clear Search
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="!isLoading && mockInterviews.length > 0">
          <div
            class="interview-card mock-interview-card"
            *ngFor="let interview of mockInterviews; trackBy: trackByRoundId"
          >
            <div class="card-header">
              <div class="left-section">
                <div class="company-logo-wrap">
                  <img
                    *ngIf="interview.practice_company_logo"
                    [src]="interview.practice_company_logo"
                    (error)="interview.practice_company_logo = null"
                    [alt]="interview.practice_company_name || 'Company'"
                  />
                  <div
                    *ngIf="!interview.practice_company_logo"
                    class="company-logo-placeholder"
                  >
                        {{ interview.practice_company_name?.charAt(0)?.toUpperCase() || '?' }}
                  </div>
                </div>

                <div class="title-section">
                  <h3 class="role-title" [title]="interview.job_role">
                    {{ interview.job_role }}
                  </h3>
                  <span
                    class="company-name"
                    [title]="interview.practice_company_name"
                  >
                    {{
                      interview.practice_company_name || "Practice Interview"
                    }}
                  </span>
                </div>
              </div>

              <span
                class="category-pill"
                [class.technical]="
                  interview.interview_category?.toLowerCase() === 'technical'
                "
                [class.management]="
                  interview.interview_category?.toLowerCase() === 'management'
                "
                *ngIf="interview.interview_category"
              >
                {{ interview.interview_category }}
              </span>
            </div>

            <div class="card-body">
              <div class="meta-row">
                <div class="meta-item">
                  <div class="meta-icon video-icon">
                    <i class="bi bi-camera-video"></i>
                  </div>
                  <span class="meta-text">AI Interview</span>
                </div>

                <div class="meta-item">
                  <div class="meta-icon time-icon">
                    <i class="bi bi-clock"></i>
                  </div>
                  <span class="meta-text">
                    {{ interview.total_duration_minutes || 0 }} Minutes
                  </span>
                </div>
              </div>

              <button
                class="start-mock-btn"
                (click)="
                  startMockInterview(
                    interview.id ||
                      interview._id ||
                      interview.screening_round_id
                  )
                "
              >
                <span>Start Mock Interview</span>
                <i class="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>
        </ng-container>
      </div>

      <button
        type="button"
        (click)="scrollRight()"
        *ngIf="!isAtEnd && mockInterviews.length > 3"
        class="arrow-btn arrow-right"
        aria-label="Next interviews"
      >
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
          viewBox="0 0 24 24"
        >
          <path d="M9 5l7 7-7 7"></path>
        </svg>
      </button>
    </div>
  </div>
</section>
